export default {
  // 标题
  title: 'Ezviz Open Source Release Center',
  footer: 'Copyright © 2018 Ezviz Inc. All rights reserved',
  category: 'Category',
  model: 'Model',
  remark: 'Description',
  license: 'License',
  source: 'Source',
  inquiry: 'Inquiry',
  searchPlaceholder: 'input search text',
};



// WEBPACK FOOTER //
// ./src/locales/en_US.js